import { useAuthContext } from "@/context/auth/AuthContext";
import { useEffect } from "react";

const Logout = () => {
  const { logout } = useAuthContext();
  useEffect(() => {
    logout();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      className="rbt-countdown-area rbt-maintenance-area rbt-section-gap vh-100 d-flex align-items-center justify-content-center"
      data-black-overlay="5"
    >
      <div className="container">
        <div className="row g-5 align-items-center">
          <div className="col-lg-12">
            <div className="inner">
              <div className="section-title text-center">
                <span className="subtitle bg-white-opacity">Hang On</span>
                <h2 className="title color-white">Logging Out</h2>
                <p className="description has-medium-font-size mt--20 mb--0 color-white opacity-7">
                  Please wait for a moment while we log you out from the
                  dashboard
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Logout;
